export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'profile',
    name: '个人资料',
    description: '泷泽萝拉的完整个人档案，包含身高、三围、血型、星座等详细信息',
    icon: 'ri-user-heart-line',
  },
  {
    slug: 'debut',
    name: '出道经历',
    description: '泷泽萝拉从出道到成名的完整历程回顾，见证她的每一步成长',
    icon: 'ri-star-line',
  },
  {
    slug: 'works',
    name: '作品全集',
    description: '泷泽萝拉全部影视作品、综艺节目及活动的完整收录',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'photobook',
    name: '写真集',
    description: '泷泽萝拉出版的写真集与电子写真全收录，展现多面魅力',
    icon: 'ri-camera-lens-line',
  },
  {
    slug: 'news',
    name: '最新动态',
    description: '泷泽萝拉最新活动、社交媒体动态及媒体报道实时更新',
    icon: 'ri-flashlight-line',
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}